/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react';
import { CouponEnum } from '../../../enums/couponEnum';
import { useTranslation } from 'react-i18next';
import axios from '../../../lib/axios';
import { CREATE_COUPON, FIND_MANY_COUPON, UPDATE_COUPON } from '../../../lib/endpoints/coupon';
import moment from 'moment';
import { CouponModel } from '../../../models/coupon';
import { SelectChangeEvent } from '@mui/material';
import { MerChantModel } from '../../../models/merChantModel';

interface Props {
  onFetchData: Function;
  onClose: VoidFunction;
  couponData: CouponModel;
  setCoupon: Function;
  branchValue: string;
  selectCouponType: CouponEnum;
  dataMerchant: MerChantModel[];
}

export const useFormCouponController = ({
  onFetchData,
  onClose,
  couponData,
  setCoupon,
  branchValue,
  selectCouponType,
  dataMerchant,
}: Props) => {
  const [couponType, setCouponType] = useState<CouponEnum>(selectCouponType);

  const { t } = useTranslation('global')


  const handleSelectCouponType = (e: SelectChangeEvent) => {
    setCouponType(e.target.value as CouponEnum);
  };

  return {
    couponType,
    handleSelectCouponType,
  };
};
